import { render, staticRenderFns } from "./CustomerReceivable.vue?vue&type=template&id=e62663d8&"
import script from "./CustomerReceivable.vue?vue&type=script&lang=js&"
export * from "./CustomerReceivable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports